// ProjectContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
const path = "ProjectImages/";
const ProjectContext = createContext();

export const useProject = () => {
  return useContext(ProjectContext);
};

export const ProjectProvider = ({ children }) => {
  const [projects] = useState([
    {
      id: 1,
      name: "Travel Experts",
      description: `"Travel Experts" is a full stack travel booking platform built using **Next.js** and **Tailwind CSS**. The application offers a sleek and responsive UI for users to explore destinations, view packages, and make bookings. It incorporates server-side rendering and modern design principles to ensure fast performance and an intuitive user experience.`,
      category: "Web Application",
      partDone: ["Concept", "Design", "Web"],
      technologies: "Next.js and Tailwind CSS",
      preview: "https://travelexperts.agency", 
      images: [
        `${path}Travel_Experts/1.png`,
        `${path}Travel_Experts/2.png`,
        `${path}Travel_Experts/3.png`,
        `${path}Travel_Experts/4.png`,
        `${path}Travel_Experts/5.png`,
        `${path}Travel_Experts/6.png`,
      ],
    },
    {
      id: 4,
      name: "The Showplace",
      description: `"The Showplace" is a streamlined movie ticket booking application developed with **Laravel (8)** and **MySQL**. The app facilitates the effortless discovery and reservation of tickets for a wide selection of movies, ensuring an intuitive user experience and seamless functionality. The platform enables users to explore showtimes, select seats, and book tickets with ease.`,
      category: "Web Application",
      partDone: ["Concept", "Design", "Web"],
      technologies: "Laravel(8) and MySql",
      preview: "",
      source_code: "https://github.com/Sabooralt/The_Showplace",
      images: [
        `${path}The_Showplace/home.png`,
        `${path}The_Showplace/home2.png`,
        `${path}The_Showplace/login.png`,
        `${path}The_Showplace/TicketBooking.png`,
        `${path}The_Showplace/TicketBooking1.png`,
        `${path}The_Showplace/TicketBooking2.png`,
        `${path}The_Showplace/TicketBooking3.png`,
      ],
    },
    {
      id: 6,
      name: "Cryptopedia",
      description: `"Cryptopedia" is an informative static website built to educate users about various aspects of cryptocurrency, including **crypto trading**, **crypto mining**, **blockchain technology**, and **NFTs**. The project leverages **front-end development** techniques and the **TradingView API** to provide real-time charts and data for users looking to dive deep into the world of digital currencies.`,
      category: "Web Application",
      partDone: ["Concept", "Design", "Web"],
      technologies: "Front-end Development and TradingView API",
      preview: "sabooralt.github.io/Cryptopedia",
      source_code: "https://github.com/Sabooralt/Cryptopedia",
      images: [
        `${path}Cryptopedia/home.png`,
        `${path}Cryptopedia/actualhome.png`,
        `${path}Cryptopedia/login.png`,
        `${path}Cryptopedia/charts.png`,
        `${path}Cryptopedia/information.png`,
        `${path}Cryptopedia/contact.png`,
      ],
    },
    {
      id: 7,
      name: "Infantique",
      description: `"Infantique" is a mobile application developed to assist parents and caregivers in finding and purchasing a wide range of **infant products**, from **diapers** and **baby food** to **clothing** and **toys**. Built with **Flutter** and **Firebase**, the app provides a user-friendly platform for shopping and product discovery, making parenting easier and more efficient.`,
      category: "Mobile Application",
      partDone: ["Concept", "Design", "App"],
      technologies: "Flutter and Firebase",
      source_code: "https://github.com/Sabooralt/Infantique",
      apk_file: "",
      images: [
        `${path}Infantique/1.png`,
        `${path}Infantique/2.png`,
        `${path}Infantique/3.png`,
        `${path}Infantique/4.png`,
        `${path}Infantique/5.png`,
        `${path}Infantique/6.png`,
        `${path}Infantique/7.png`,
        `${path}Infantique/8.png`,
      ],
    },
    {
      id: 2,
      name: "Luxury Stay",
      description: `"Luxury Stay" is a modern **hotel management system** built with the **MERN stack**. The system utilizes **Socket.io** for real-time updates and **React Context API** for efficient state management, ensuring seamless synchronization between hotel staff and guests. The platform provides a unified solution for booking management, check-ins, and staff coordination, enhancing the overall guest experience and operational efficiency.`,
      category: "Web Application",
      partDone: ["Concept", "Design", "Web"],
      technologies:
        "ReactJs, NodeJs, ExpressJs, MongoDB, TailwindCSS, ShadCN, and Socket.io",
      source_code: "https://github.com/Sabooralt/LuxuryStay_Hospitality/",
      preview: "https://luxury-stay.vercel.app",
      images: [
        `${path}Luxury_Stay/1.png`,
        `${path}Luxury_Stay/2.png`,
        `${path}Luxury_Stay/3.png`,
        `${path}Luxury_Stay/4.png`,
        `${path}Luxury_Stay/5.png`,
        `${path}Luxury_Stay/6.png`,
        `${path}Luxury_Stay/7.png`,
        `${path}Luxury_Stay/A1.png`,
        `${path}Luxury_Stay/A2.png`,
        `${path}Luxury_Stay/A3.png`,
        `${path}Luxury_Stay/S1.png`,
        `${path}Luxury_Stay/S2.png`,
        `${path}Luxury_Stay/S3.png`,
      ],
    },
    {
      id: 3,
      name: "Ponke Coin",
      description:
        "I developed this full-stack Play2Earn application using Next.js, fully integrated with a Telegram bot. The platform allows users to earn points by completing social tasks, clicking a main button, or referring others. It features a unique energy system, where users lose energy with each click and regain it over time, adding a layer of gamification and strategy. I also built a custom admin dashboard to manage users, track activity, and control the platform's operations.",
      category: "Web Application",
      partDone: ["Concept", "Design", "Web"],
      technologies: "Next.js, MongoDB, Prisma, CRON Jobs, and Telegram API",
      preview: "https://t.me/PonkeCoinOfficial",
      images: [
        `${path}PonkeCoin/Ponke1.png`,
        `${path}PonkeCoin/Ponke2.png`,
        `${path}PonkeCoin/Ponke3.png`,
        `${path}PonkeCoin/Ponke4.png`,
      ],
    },
    {
      id: 4,
      name: "TCH Portfolio",
      description: `"TCH Portfolio" is a professional portfolio website developed for a client. The primary task was to convert a detailed Figma design into a fully responsive React application. I used **React.js** and **Tailwind CSS** to ensure pixel-perfect accuracy, creating a clean and modern layout that is fully optimized for performance across all devices. The project serves as a showcase for the TCH company, highlighting their work and services.`,
      category: "Web Application",
      partDone: ["Concept", "Design", "Web"],
      technologies: "React.js and Tailwind CSS",
      preview: "https://tch-portfolio.vercel.app/",
      images: [
        `${path}TCH/1.png`,
        `${path}TCH/2.png`,
        `${path}TCH/3.png`,
        `${path}TCH/4.png`,
        `${path}TCH/5.png`,
      ],
    },
    {
      id: 41,
      name: "Train Ticket Booking System",
      description: `This project is a fully automated KTMB train ticket booking system built for a client, designed to simplify the booking process using a Telegram bot. Users interact with the bot to provide their travel details, including date, destination, and passenger info. Once the information is submitted, the system automatically logs in and books the ticket on the KTMB website, intelligently handling wait times and queue delays through a custom queue management system. Cron jobs are used to schedule bookings at precise times, such as when tickets drop early in the morning. Throughout the process, users are kept fully informed via real-time Telegram bot notifications — from booking confirmation to any errors or updates. An admin dashboard, built with Next.js, allows the client to monitor and manage all bookings, users, and refund requests in one place, making the entire system robust, scalable, and easy to control.`,
      category: "Scripting & Automation",
      partDone: ["Bot Development", "Script", "Admin Dashboard"],
      technologies:
        "Node.js, Puppeteer, Puppeteer-cluster, CRON Jobs, Telegram Bot, Next.js and Tailwind CSS",
      images: [`${path}KTMB/1.png`, `${path}KTMB/2.png`, `${path}KTMB/3.png`],
      media: [`${path}KTMB/video.mp4`],
    },
    {
      id: 42,
      name: "TornCity: Chrome Extension",
      description: `A feature-rich Chrome extension built to enhance the TornCity gameplay experience. It includes three customizable pages with draggable, color-coded groups for organizing links, notes, and tools. Users can manage to-do lists with auto-reset, track loans with payment history, and monitor auctions with live countdowns. \n

Additional tools include a built-in calculator, custom timers, notepads, and an attack list for quick access to player profiles. The UI is fully customizable with dark/light modes, resizable elements, and safe auto-save with import/export options for easy backup and transfer. \n

Designed for seamless user experience and flexibility, with potential for future feature expansions.`,
      category: "Scripting & Automation",
      partDone: ["Extension Development", "Script"],
      technologies: "HTML, CSS, JavaScript, Chrome Extension API, and Webpack",
      images: [`${path}TORN/2.png`, `${path}TORN/3.png`, `${path}TORN/4.png`],
    },
  ]);

  const preloadImages = (imagePaths) => {
    imagePaths.forEach((src) => {
      const img = new Image();
      img.src = src;
      console.log(`${img.src} loaded!`);
    });
  };

  useEffect(() => {
    projects.forEach((project) => preloadImages(project.images));
  }, [projects]);

  const [currentProjectId, setCurrentProjectId] = useState(projects[0].id);

  const setCurrentProject = (projectId) => {
    setCurrentProjectId(projectId);
  };

  const getCurrentProject = () => {
    return projects.find((project) => project.id === currentProjectId);
  };

  return (
    <ProjectContext.Provider
      value={{
        projects,
        currentProjectId,
        setCurrentProject,
        getCurrentProject,
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
